import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Api from '@/interfaces/Api';

export default class NonCommodityRegistrationUpload {
  public side?: string;
  public file?: string;
  public previewUrl: string = '';
  public isUploaded: boolean = false;
  public isUploading: boolean = false;
  public isPdf: boolean = false;
  public sizeError: boolean = false;
  public fileTypeError = false;

  public static withData(data: Record<any, any>): NonCommodityRegistrationUpload {
    return Object.assign(new NonCommodityRegistrationUpload(), data);
  }

  public reset(): NonCommodityRegistrationUpload {
    this.file = '';
    this.previewUrl = '';
    this.isUploaded = false;
    this.isUploading = false;
    this.isPdf = false;
    this.sizeError = false;
    this.fileTypeError = false;
    return this;
  }

  public async loadPreviewFromGenericData(): Promise<any> {
    this.isUploading = true;
    return await this.apiProvider.getGenericData(this.side ?? '').then((response) => {
      if (response.data && response.data.fileName && response.data.fileName.length > 0) {
        if ((response.data.data && response.data.data.length > 0) || response.data.isPdf) {
          this.apiProvider.checkFileExists({ key: response.data.s3Key }).then((res) => {
            if (res.data.exists) {
              this.file = response.data.fileName;
              if (response.data.fileType != 'application/pdf') {
                this.previewUrl =
                  response.data.data.substring(0, 4) === 'data'
                    ? response.data.data
                    : 'data:' + response.data.fileType + ';base64,' + response.data.data;
              } else {
                this.isPdf = true;
              }
              this.isUploaded = true;
            } else {
              this.isUploaded = false;
            }
          });
        }
      }
      this.isUploading = false;
    });
  }

  private get apiProvider() {
    return IocContainer.get<Api>(SERVICES.API);
  }
}
